import React, { useState } from 'react';
import DefaultButton from '@src/components/ui-kit/buttons/DefaultButton';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import {
  FindManyUserSceneAssetsDocument,
  useUpdateUserSceneAssetsMutation,
} from '@src/components/generated/graphql';
import { prodLinks, marketplaceStaging, IS_PROD } from 'util/constants';
import styles from './created-assets.module.css';

const marketLink = IS_PROD ? prodLinks.marketplace : marketplaceStaging;

const EcommerceElement = ({ el }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [updateAsset] = useUpdateUserSceneAssetsMutation();

  const enablePurchase = async (id, value: boolean) => {
    setIsLoading(true);
    await updateAsset({
      variables: {
        where: {
          id,
        },
        data: {
          enablePurchase: {
            set: value,
          },
        },
      },
      refetchQueries: [FindManyUserSceneAssetsDocument],
    });
    setIsLoading(false);
  };

  return (
    <div key={el.id} className={styles.card}>
      <div className={styles.info}>
        <div className={styles.name}>{el.name}</div>
        <div>
          <a
            href={`${marketLink}asset?id=${el.marketId}`}
            target='_blank'
            rel='noreferrer'
            className={styles.link}
          >
            marketplace asset page
          </a>
        </div>
      </div>
      {el.enablePurchase ? (
        <DefaultButton
          style={{ width: 180 }}
          type='secondary'
          onClick={() => enablePurchase(el.id, false)}
        >
          {isLoading ? (
            <Spin indicator={<LoadingOutlined />} spinning />
          ) : (
            <span>Disable purchase</span>
          )}
        </DefaultButton>
      ) : (
        <DefaultButton
          style={{ width: 180 }}
          type='primary'
          onClick={() => enablePurchase(el.id, true)}
        >
          {isLoading ? (
            <Spin indicator={<LoadingOutlined />} spinning />
          ) : (
            <span style={{ color: '#fff' }}>Enable purchase</span>
          )}
        </DefaultButton>
      )}
    </div>
  );
};

export default EcommerceElement;
